import React from 'react';
import classNames from 'classnames';
import {ReactComponent as Icon} from 'images/player/Share.svg';

export default class ShareIcon extends React.PureComponent {
  render() {
    return (
      <Icon
        className={classNames('icon share', this.props.className)}
        onClick={this.props.onClick}
      />
    );
  }
}
